import { SetContextLink } from '@apollo/client/link/context';
import { i18n } from '@lingui/core';

import { LOCALE_HEADER_NAME } from '@/apollo/constants/LocaleHeaderName';

// Read on every request, so switching language applies to the next one.
export const createLocaleLink = () =>
  new SetContextLink(({ headers }) => ({
    headers: { ...headers, [LOCALE_HEADER_NAME]: i18n.locale },
  }));
